import React from "react";
import { Box, Typography, Paper } from "@material-ui/core";

function AboutReadinessTab({ }) {
    return (
        <Box display="flex" justifyContent="center" width="100%">
            <Paper
                elevation={0}
                style={{
                    maxWidth: 1300,
                    minHeight: 510,
                    width: "100%",
                    margin: "0 auto",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "40px 36px 32px 36px",
                }}
            >
                <Typography style={{ marginBottom: 18 }}>
                    The AI Readiness Assessment is specifically developed to assess AI readiness among young people (ages 8–18). It provides insightful, age-appropriate evaluations to help parents and educators understand and effectively support youth in enhancing their competencies with AI, digital media, and technology.
                </Typography>
                <Typography style={{ marginBottom: 18 }}>
                    This includes an integrated summary derived from seven targeted assessment surveys, covering these critical areas:
                </Typography>
                <Box component="ul" pl={3} mb={4} style={{ marginTop: 0 }}>
                    <li>
                        <b>AIR1:</b> Digital Engagement and Adoption Index – Measures the nature and extent of youth's digital engagement and technology adoption.
                    </li>
                    <li>
                        <b>AIR2:</b> Youth Cyber Safety Index – Evaluates young people's behaviors related to maintaining online safety.
                    </li>
                    <li>
                        <b>AIR3:</b> Digital Literacy Skills Index – Assesses core digital literacy skills and competencies necessary for effectively navigating digital environments safely and responsibly.
                    </li>
                    <li>
                        <b>AIR4:</b> AI Essential Skills Index – Analyzes foundational skills for using and understanding artificial intelligence tools.
                    </li>
                    <li>
                        <b>AIR5:</b> Youth Perceived Digital Support Index – Captures young people's perceptions of digital support provided by their parents, caregivers, and educators.
                    </li>
                    <li>
                        <b>AIR6:</b> Digital Parenting Index – Reviews parents' and caregivers' competencies and readiness to support youth in digital and AI engagement.
                    </li>
                    <li>
                        <b>AIR7:</b> School AI Readiness Index – Measures educational institutions' readiness and capability to integrate and support AI and digital literacy initiatives.
                    </li>
                </Box>
                <Typography style={{ marginBottom: 18 }}>
                    Among these surveys, your child has completed the following assessment(s). This report summarizes your child's scores and provides guidance to help your child become AI-ready—equipped to use digital technology safely, responsibly, and effectively in daily life and school work, ensuring their future success and well-being.
                </Typography>

                <Typography style={{ margin: "32px 0 0 0", fontWeight: 600 }}>
                    Completed Assessment:
                </Typography>
                <Typography style={{ marginTop: 2 }}>
                    • AIR1: Digital Engagement and Adoption Index
                </Typography>
            </Paper>
        </Box>
    );
}

export default AboutReadinessTab;